var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_cof.js
// module id = 769
// module chunks = 2